module.exports = __webpack_public_path__ + "static/supercell-bg-a15bcbbb833db4f1908a54d23a92a904.png";